import React from 'react';

import {
  AddSuperAdminModal,
  appEvents,
  ConfirmModal,
  CreateUserAccountModal,
  EditActorStageModal,
  EditInvestmentAreaModal,
  EditInvestorCardModal,
  FundraisingCampaignModal,
  ManageDownloadLimitsModal,
  NotifyModal,
  SaveNoteModal,
  EditUserModal,
  UploadInvestmentAreasModal,
  UploadUsersModal,
  EditAccessPassModal
} from 'modules';
import { filter } from 'rxjs';



export interface IProps { }

export const FC: React.FC<IProps> = props => {
  const [currentModalArgs, setCurrentModalArgs] = React.useState<appEvents.IModalEvent | null>(null);

  React.useEffect(() => {
    const subscriber = appEvents
      .observable()
      .pipe(filter(ev => ev?.type === 'modal'))
      .subscribe(event => {
        if (event && event.type === 'modal') {
          setCurrentModalArgs(old => {
            if (old?.type === 'modal' && old.onClose) {
              old.onClose();
            }

            return event;
          });
        }
      });

    return () => {
      subscriber.unsubscribe();
    };
  }, []);



  const args = currentModalArgs?.args;

  if (!args) {
    return <></>;

  } else if (args === 'close') {
    setCurrentModalArgs(null);
    return <></>;
  }


  if (args.type === 'editInvestorCard') {
    return (
      <EditInvestorCardModal.FC
        id={args.id}
        campaignId={args.campaignId} />
    );

  } else if (args.type === 'editActorStageModal') {
    return (
      <EditActorStageModal.FC actorStageName={args.actorStageName} />
    );

  } else if (args.type === 'editFundraisingCampaign') {
    return (
      <FundraisingCampaignModal.FC
        mode="edit"
        campaignId={args.campaignId} />
    );

  } else if (args.type === 'createFundraisingCampaign') {
    return (
      <FundraisingCampaignModal.FC
        mode="create" />
    );

  } else if (args.type === 'addSuperAdmin') {
    return (
      <AddSuperAdminModal.FC />
    );

  } else if (args.type === 'saveNoteModal') {
    return (
      <SaveNoteModal.FC
        isOpen
        investorCardId={args.investorCardId}
        id={args.id} />
    );

  } else if (args.type === 'editUserModal') {
    return (
      <EditUserModal.FC
        siteUserId={args.siteUserId}
        companyProfileId={args.companyProfileId}
        investorProfileId={args.investorProfileId} />
    );

  } else if (args.type === 'confirm') {
    return (
      <ConfirmModal.FC
        title={args.title}
        body={args.body}
        onConfirm={args.onConfirm} />
    );

  } else if (args.type === 'notify') {
    return (
      <NotifyModal.FC
        title={args.title}
        body={args.body} />
    );

  } else if (args.type === 'uploadUsers') {
    return (
      <UploadUsersModal.FC type={args.userType} />
    );

  } else if (args.type === 'createUserAccount') {
    return (
      <CreateUserAccountModal.FC
        userId={args.userId}
        defaultEmail={args.defaultEmail} />
    );

  } else if (args.type === 'editInvestmentArea') {
    return (
      <EditInvestmentAreaModal.FC investmentAreaId={args.investmentAreaId} />
    );

  } else if (args.type === 'uploadInvestmentAreas') {
    return (
      <UploadInvestmentAreasModal.FC />
    );

  } else if (args.type === 'manageDownloadLimits') {
    return (
      <ManageDownloadLimitsModal.FC />
    );

  } else if (args.type === 'editAccessPass') {
    return (
      <EditAccessPassModal.FC accessPassId={args.accessPassId} />
    );
  }

  return (
    <div />
  );
};
